/* ────────────────────────────────────────────────────────────────────────── */
/*  Theme                                                                     */
/* ────────────────────────────────────────────────────────────────────────── */

/* UI template (device-local, Profile > Appearance): 'classic' is the original
 * look, 'compact' the calmer iOS-like one (borderless cards, blue, bottom tabs). */
export const UI_KEY = 'xceller_fit_ui';
export function readUi() {
  try { return localStorage.getItem(UI_KEY) === 'compact' ? 'compact' : 'classic'; } catch { return 'classic'; }
}

const COMPACT = {
  dark: {
    bg: '#000000', surface: '#0d0d0e', surfaceAlt: '#2c2c2e', cardBg: '#1c1c1e', cardBorder: 'transparent',
    cardBorderHover: 'transparent', text: '#f5f5f7', textMuted: '#98989f', textFaint: '#636366', divider: '#2c2c2e',
    accent: '#0a84ff', accentSoft: 'rgba(10, 132, 255, 0.16)', accentBorder: 'rgba(10, 132, 255, 0.5)',
    inputBg: '#2c2c2e', inputBorder: 'transparent', inputFocus: '#0a84ff', rowBg: '#1c1c1e', rowAlt: '#1c1c1e',
    headerBg: 'rgba(0, 0, 0, 0.85)', badgeBg: '#2c2c2e', navBg: 'rgba(18, 18, 18, 0.94)', cardRadius: 16,
  },
  light: {
    bg: '#f2f2f7', surface: '#ffffff', surfaceAlt: '#f2f2f7', cardBg: '#ffffff', cardBorder: 'transparent',
    cardBorderHover: 'transparent', text: '#1c1c1e', textMuted: '#6c6c70', textFaint: '#aeaeb2', divider: '#e5e5ea',
    accent: '#007aff', accentSoft: 'rgba(0, 122, 255, 0.10)', accentBorder: 'rgba(0, 122, 255, 0.4)',
    inputBg: '#f2f2f7', inputBorder: 'transparent', inputFocus: '#007aff', rowBg: '#ffffff', rowAlt: '#ffffff',
    headerBg: 'rgba(242, 242, 247, 0.9)', badgeBg: '#f2f2f7', navBg: 'rgba(249, 249, 249, 0.94)', cardRadius: 16,
  },
};

export function getTokens(isDark, ui = 'classic') {
  const base = classicTokens(isDark);
  return ui === 'compact' ? { ...base, ...COMPACT[isDark ? 'dark' : 'light'] } : base;
}

function classicTokens(isDark) {
  return isDark ? {
    bg: '#0a0a0a',
    surface: '#111111',
    surfaceAlt: '#161616',
    cardBg: '#141414',
    cardBorder: '#262626',
    cardBorderHover: '#3a3a3a',
    text: '#fafafa',
    textMuted: '#a3a3a3',
    textFaint: '#525252',
    divider: '#222222',
    accent: '#10b981',
    accentSoft: 'rgba(16, 185, 129, 0.12)',
    accentBorder: 'rgba(16, 185, 129, 0.4)',
    danger: '#f43f5e',
    dangerSoft: 'rgba(244, 63, 94, 0.12)',
    inputBg: '#1a1a1a',
    inputBorder: '#2a2a2a',
    inputFocus: '#3a3a3a',
    rowBg: '#141414',
    rowAlt: '#181818',
    headerBg: 'rgba(10, 10, 10, 0.85)',
    badgeBg: '#1f1f1f',
  } : {
    bg: '#fafafa',
    surface: '#ffffff',
    surfaceAlt: '#f5f5f5',
    cardBg: '#ffffff',
    cardBorder: '#e5e5e5',
    cardBorderHover: '#d4d4d4',
    text: '#0a0a0a',
    textMuted: '#525252',
    textFaint: '#a3a3a3',
    divider: '#e5e5e5',
    accent: '#10b981',
    accentSoft: 'rgba(16, 185, 129, 0.10)',
    accentBorder: 'rgba(16, 185, 129, 0.45)',
    danger: '#e11d48',
    dangerSoft: 'rgba(225, 29, 72, 0.08)',
    inputBg: '#ffffff',
    inputBorder: '#e5e5e5',
    inputFocus: '#a3a3a3',
    rowBg: '#ffffff',
    rowAlt: '#fafafa',
    headerBg: 'rgba(255, 255, 255, 0.92)',
    badgeBg: '#f5f5f5',
  };
}

export const FONT_BODY = '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
// A CSS variable, so the compact template can swap the number font (Inter with
// tabular figures) without touching every inline style.
export const FONT_MONO = 'var(--fit-mono, "IBM Plex Mono", "SF Mono", Menlo, monospace)';
